/* Utils */
import { tvService } from '../../../../services/authService';
import { setAccessTokenData } from '../../../../utils/accessTokenData';
import { TOOLBOX_IS_TEST_REFRESH_TOKEN } from '../../../../utils/env';

async function accessTokenToolbox(loginDeviceParams) {
  const { deviceCode } = loginDeviceParams;
  const responseAccessToken = await tvService.v2.tv.loginDevice(deviceCode);
  const isToolboxTestRefreshToken = TOOLBOX_IS_TEST_REFRESH_TOKEN || false;
  if (responseAccessToken?.status !== 200) throw responseAccessToken;
  const {
    id_token: idToken,
    access_token: accessToken,
    refresh_token: refreshToken,
    expires_in: expiresIn,
  } = responseAccessToken?.data || {};
  const accessTokenData = {
    idToken,
    accessToken,
    refreshToken,
    expiresIn: isToolboxTestRefreshToken ? 600 : expiresIn,
    timestamp: Math.floor(Date.now() / 1000) * 1000,
  };
  setAccessTokenData(accessTokenData);
  return accessTokenData;
}

export default async function loginDeviceToolbox(loginDeviceParams) {
  try {
    await accessTokenToolbox(loginDeviceParams);
  } catch (error) {
    console.error('loginDeviceToolbox', error);
    throw error;
  }
}
